
import React from 'react';
import { ComboBox, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import styles from './_lease-loan-class-selector.module.scss';
import {IApplication} from "../../../../Interfaces/Application/IApplication";
import {ILeaseLoanClass} from "../../../../Interfaces/Common/ILeaseLoanClass";
import {IConfiguration} from "../../../../Data/ConfigurationData";
import {ILookupItems} from "../../../../Interfaces/ILookupItems";
import {IRuleViolation} from "../../../../Interfaces/Application/IApplicationQuote";
import {getLeaseQuoteErrorMessages} from "../../../../utils/quoteUtils";
import QuoterError from "../../QuoterError/QuoterError";

export interface LeaseLoanClassSelectorProps {
  lookups: ILookupItems;
  currentApp: IApplication;
  configuration: IConfiguration;
  leaseQuoteFieldIsDisabled: (fieldName: string) => boolean;
  selectedLeaseLoanClass: ILeaseLoanClass | undefined;
  handleChangeSelectedLeaseLoanClass: (newLoanClassId: string | undefined) => void;
  applicationLeaseErrors: IRuleViolation[];
}

export default function LeaseLoanClassSelector(props: LeaseLoanClassSelectorProps) {
  const leaseLoanClasses = props.lookups.leaseLoanClasses.filter(lc =>
    !lc.deletedDate || lc.id === props.selectedLeaseLoanClass?.id
  );
  
  return (
    <div className={styles.leaseLoanClassSelectorContainer}>
      <div className={styles.sectionItem}>
        <ComboBox
          disabled={props.leaseQuoteFieldIsDisabled("leaseLoanClassId")}
          label={'Loan Class'}
          data={leaseLoanClasses}
          textField="description"
          suggest={true}
          clearButton={false}
          value={props.selectedLeaseLoanClass}
          onChange={(event: ComboBoxChangeEvent) => {
            props.handleChangeSelectedLeaseLoanClass((event.value as ILeaseLoanClass).id);
          }}
        />
        <QuoterError message={getLeaseQuoteErrorMessages(props.applicationLeaseErrors).leaseLoanClassId}/>
      </div>
    </div>
  );
}
